import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './account-password-reset-layout.module.scss';

const PasswordResetLayout: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <h1 className={styles.pageTitle}>{t('password_reset.page_title')}</h1>
        {children}
      </div>
    </div>
  );
};

export default PasswordResetLayout;
